import { GlobalDrawer } from './GlobalDrawer';

export class GlobalDrawerClose extends GlobalDrawer {
  constructor() {
    super({ name: 'close' });
  }
}
